import { QueryClient } from '@tanstack/react-query'

/**
 * Sunucu durumu TanStack Query'de tutulur; `useEffect` ile veri çekmek yasaktır
 * (docs/standards/frontend-standards.md §4).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Ücretli işlemler tekrar denenmez: çift ücretlendirme riski
        // (docs/spec/05-mersis-integration.md §1).
        retry: false,
      },
    },
  })
}
